// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1p0cQ","index":"styles_index__3fUJL"};